import _ from 'lodash';
import React from 'react';
import { Row, Col, PanelGroup, Panel } from 'react-bootstrap'
import MdDelete from 'react-icons/lib/md/delete'
import * as actions from '../../Actions';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Moment from 'react-moment';
import Modal from 'react-modal';
import SelectField from 'material-ui/SelectField';
import TextField from 'material-ui/TextField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import LinearProgress from 'material-ui/LinearProgress';

Modal.setAppElement('#root')
const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		width: '500px',
		transform: 'translate(-50%, -50%)'
	}
};

const  TemplateNames = {
	'COVER': 'Title Cover Sheet',
	'AUDIO_VISUAL': 'Audio Visual (AV)',
	'OTHER_WORKS' : 'Other Works (OW)',
	'ELECTRICAL': 'Electrical (EL)',
	'FIRE_DETECTION' : 'Fire Detection (FIRE)',
	'MECHANICAL' : 'Mechanical (MECH)',
	'SECURITY' : 'Security (SEC)',
	'VOICE_DATA' : 'Voice Data (DATA)',
	'FLOORING' : 'Flooring (FLOOR)',
	'ROOFING' : 'Roofing (RF)',
	'HVAC' : 'HVAC (HV)',
	'RENEWABLES': 'Renewables (RN)'
}
class Templete extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			modalIsOpen: false,
			templatetitle: '',
			templateid: '',
			manualid: '',
			values: [],
			addTemplatemodalIsOpen: false,
			selectManual: '',
			actionType: '',
			newMainTemplateName: '',
			modalIsOpenDeleteTemp: false,
			templateNameReq: ''
		}
		this.closeModal = this.closeModal.bind(this);
		this.openModal1 = this.openModal1.bind(this);
		this.openModal = this.openModal.bind(this);
		this.registerFileToUpload = this.registerFileToUpload.bind(this);
		this.uploadTemplateFile = this.uploadTemplateFile.bind(this);
		this.stopFormSubmit = this.stopFormSubmit.bind(this);
		this.addNewManualType = this.addNewManualType.bind(this);
		this.checkManual = this.checkManual.bind(this);
		this.closeModalDeleteTemp = this.closeModalDeleteTemp.bind(this);
		this.changeNewMainTemplateName = this.changeNewMainTemplateName.bind(this);
	}
	handleChange = (event, index, values) => this.setState({ values });
	openModal() {
		this.setState({ addTemplatemodalIsOpen: true });
	}
	openModalDeleteTemp(template) {
		this.setState({ modalIsOpenDeleteTemp: true, deleteTempId: template._id });
	}
	closeModalDeleteTemp() {
		this.setState({ modalIsOpenDeleteTemp: false });
	}
	componentDidMount() {
		/*let companyid = this.props.userdetail.company ? this.props.userdetail.company._id : '';
		if (companyid) {
			this.props.fetchManuals(companyid);
		}*/
	}
	componentWillReceiveProps(newProps) {
		const templates = newProps.templates;
		if (templates.newTemplateAdded) {
			this.props.fetchLoginUserDetail();
			this.props.unsetNewTemplateAddedFlag();
		}
	}
	stopFormSubmit(e) {
		e.preventDefault();
	}
	openModal1(e, type) {
		this.setState({ modalIsOpen: true, templatetitle: e.title, templateid: e._id, manualid: e.manual, actionType: type });
	}
	closeModal() {
		this.setState({ modalIsOpen: false, addTemplatemodalIsOpen: false });
	}
	registerFileToUpload(e) {
		const files = [...e.target.files];
		this.setState({
			uploadFiles: files
		});
	}
	changeNewMainTemplateName(e) {
		this.setState({ newMainTemplateName: e.target.value });
	}
	uploadTemplateFile(manual_id, template_id) {
		let nameField = document.uploadTemplateForm.newMainTemplateName;
		let newMainTemplateName = nameField && document.uploadTemplateForm.newMainTemplateName.value;

		let companyid = this.props.currentuser.companydetail.company_id;
		let newTemplateName = this.state.newMainTemplateName;

		if (this.state.actionType === 'newmain' && newMainTemplateName == '') {
			this.setState({ templateNameReq: 'Template name must be entered.' });
			return false;
		} else {
			this.setState({ templateNameReq: '' });
		}
		if (this.state.uploadFiles) {

			new Promise((resolve, reject) => {
				if (this.state.actionType === 'newmain') {
					this.props.uploadNewTemplateFile(manual_id, template_id, companyid, this.state.uploadFiles, newTemplateName)
						.then((json) => {
							resolve(json)
						});
				} else {
					this.props.uploadTemplateFile(manual_id, template_id, companyid, this.state.uploadFiles)
						.then((json) => {
							resolve(json)
						});
				}
			})
				.then((json) => {
					if (this.filesInput) {
						this.filesInput.value = '';
					}
					window.location.reload();
				})

	        /*window.setTimeout(() => {
	        	if(this.filesInput){
		          	this.filesInput.value = '';
		  		}
	          	window.location.reload();
	        }, 2500);*/
		}
	}
	renderGroupedItems() {
		let groupedItems;
		let selectedManuals = _.keys(this.props.template_set.selectedManuals);

		const filteredItems = _.filter(this.props.templates.items, (t) => {
			return !t.subtype
		})
		let groups = _.groupBy(filteredItems, 'category');

		let manualsWithoutCover = _.omit(groups, ['COVER']);
		let manualCover = _.pick(groups, ['COVER']);

		manualsWithoutCover = _(manualsWithoutCover).toPairs().sortBy(0).fromPairs().value();
		groups = _.merge(manualCover, manualsWithoutCover);
		groupedItems = _.map(groups, (group, groupName) => {

			let manualTypes = ['MAIN', 'COVER', 'MANU_SCHED'];
			let sortedGroup = _.sortBy(group, (t) => {
				return _.indexOf(manualTypes, t.type);
			});
			// check for selected manual during signup 
			let check = _.indexOf(selectedManuals, groupName);

			if (check !== -1) {


				let items = sortedGroup.map((t, i) => {
					var lastupdated;
					if (t.lastUpdated) {
						var now = new Date(t.lastUpdated);
						lastupdated = now;
					}
					let checkForClass = t.type === "MAIN" && t.subtype == true;
					return (
						<tr key={`template-${t.title}-${i}`} className={checkForClass ? 'bg-color-none' : ''}>
							<td width="30%">{t.title}</td>
							<td width="30%">
								Updated :
      	 					{lastupdated ?
									<Moment format=" MMM-DD-YYYY HH:mm">
										{lastupdated}
									</Moment>
									: ''}
							</td>
							<td width="15%">
								{t.download ?
									<a target="_blank" href={t.download}><i className="zmdi zmdi-download"></i> Download</a>
									:
									'No Templates to download'
								}
							</td>
							<td width="15%">
								<div className="upload-file-sec text-center">
									<label htmlFor="input-file-down" onClick={(e) => { this.openModal1(t, e) }}>
										<i className="zmdi zmdi-upload"></i> Upload
      	 						</label>
								</div>
							</td>
							{/*t.type === "MAIN" ?
								t.subtype == true ?
									<td width="10%">
										<div className="upload-file-sec text-center">
											<label htmlFor="input-file-down">
												<a className="trash-tech-file" onClick={(e) => { this.openModalDeleteTemp(t) }} ><MdDelete color="#e94731" /></a>
											</label>
										</div>
									</td>
									:
									<td width="20%">
										<div className="upload-file-sec">
											<label htmlFor="input-file-down" onClick={(e) => { this.openModal1(t, 'newmain', e) }}>
												<a> add new </a>
											</label>
										</div>
									</td>
								:
								<td></td>
							*/}
						</tr>
					);
				});
				let groupNameText = '';
				let iconClass = '';
				switch (groupName) {
					case 'COVER':
						groupNameText = 'Title Cover Sheet ';
						iconClass = 'zmdi zmdi-file-text';
						break;
					case 'AUDIO_VISUAL':
						groupNameText = 'Audio Visual (AV)';
						iconClass = 'zmdi zmdi-volume-up';
						break;
					case 'OTHER_WORKS':
						groupNameText = 'Other Works (OW)';
						iconClass = 'zmdi zmdi-case';
						break;
					case 'ELECTRICAL':
						groupNameText = 'Electrical (EL)';
						iconClass = 'zmdi zmdi-input-power';
						break;
					case 'FIRE_DETECTION':
						groupNameText = 'Fire Detection (FIRE)';
						iconClass = 'zmdi zmdi-fire';
						break;
					case 'MECHANICAL':
						groupNameText = 'Mechanical (MECH)';
						iconClass = 'zmdi zmdi-wrench';
						break;
					case 'SECURITY':
						groupNameText = 'Security (SEC)';
						iconClass = 'zmdi zmdi-shield-security';
						break;
					case 'VOICE_DATA':
						groupNameText = 'Voice Data (DATA)'
						iconClass = 'zmdi zmdi-phone-in-talk';
						break;
					case 'FLOORING':
						groupNameText = 'Flooring (FLOOR)';
						iconClass = 'zmdi zmdi-grid';
						break;
					case 'ROOFING':
						groupNameText = 'Roofing (RF)';
						iconClass = 'zmdi zmdi-balance';
						break;
					case 'HVAC':
						groupNameText = 'HVAC (HV)'
						iconClass = 'zmdi zmdi-toys';
						break;
					case 'RENEWABLES':
						groupNameText = 'Renewables (RN)'
						iconClass = 'zmdi zmdi-refresh';
						break;
					default:
						break;
				}
				return (
					<Panel key={`${groupName}`} eventKey={`template-group-${groupName}`}>
						<Panel.Heading>
							<Panel.Title toggle><i className={iconClass}></i> {groupNameText} </Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible >
							<div className="dashboard-table-data">
								<table width="100%">
									<tbody>
										{items}
									</tbody>
								</table>
							</div>
						</Panel.Body>
					</Panel>
				);
			}

		});
		return groupedItems;
	}
	menuItems(values) {
		
		// let selectedManuals = _.keys(this.props.currentuser.companydetail.selectedManuals);
		
		let selectedManuals = _.keys(this.props.template_set.selectedManuals);

		let groups = _.groupBy(this.props.templates.items, 'category');
		let allManuals = _.keys(groups);
		let newManuals = _.differenceWith(allManuals, selectedManuals, _.isEqual);
		newManuals = newManuals.sort();
		if (!newManuals) {
			return null;
		}
		return newManuals.map((name) => (
			
			<MenuItem
				key={name}
				insetChildren={true}
				checked={this.state.values && this.state.values.indexOf(name) > -1}
				value={name}
				primaryText={TemplateNames[name]}
			/>
		));
	}
	checkManual() {
		let manuals = this.state.values;
		if (manuals.length === 0) {
			this.setState({ selectManual: "Oop's..!! No manual selected." })
			return false;
		} else {
			this.setState({ selectManual: '' });
			this.openModal();
		}
	}
	addNewManualType() {
		let companyid = this.props.userdetail.company ? this.props.userdetail.company._id : '';
		let manuals = this.state.values;
		if (manuals.length === 0) {
			this.setState({ selectManual: 'Please select atleast one mnaual from dropdown.' })
			return false;
		} else {
			this.setState({ selectManual: '' });
		}

		const { template_set : {_id} } = this.props

		this.props.addNewManual(manuals, companyid, _id);
	}
	removeCompanyTemplate() {
		this.closeModalDeleteTemp();
		let tempId = this.state.deleteTempId;
		this.props.removeCompanyTemplate(tempId);
	}
	render() {

		let { templates: { isUploadingFile } } = this.props;
		let groupedItems = null
			, newManuals = null;
		if (this.props.templates && this.props.templates.items && this.props.templates.items.length > 0) {
			groupedItems = this.renderGroupedItems();
			newManuals = this.menuItems(values)
		} else {
			groupedItems = 'No templates found for that company.';
		}
		let manual_id = this.state.manualid;
		let template_id = this.state.templateid;
		const uploadLabel = isUploadingFile ? 'Uploading...' : 'Upload File';
		const { values } = this.state;
		let type = this.props.currentuser.currentUser ? this.props.currentuser.currentUser.type : null;
		const actionNewTemplate = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.closeModal}
			/>,
			<RaisedButton
				label="Add New Manuals"
				primary={true}
				labelStyle={{ 'color': '#fff' }}
				keyboardFocused={true}
				onClick={this.addNewManualType}
			/>,

		];
		const actionDeleteTemplate = [
			<FlatButton
				label="Cancel"
				primary={true}
				onClick={this.closeModalDeleteTemp}
			/>,
			<RaisedButton
				label="Yes"
				primary={true}
				labelStyle={{ 'color': '#fff' }}
				keyboardFocused={true}
				onClick={(e) => { this.removeCompanyTemplate() }}
			/>
		];
		return (
			<Row>
				<Col md={12}>
					<PanelGroup accordion id="accordian-template">
						{groupedItems}
						{newManuals && newManuals.length > 0 && type === 1 ?
							<div className="new-manuals-select">
								<div className="multi-select-dis">
									<SelectField
										className="templete-multi-select"
										multiple={true}
										hintText="Select new templates"
										value={values}
										onChange={this.handleChange}
									>
										{newManuals ? newManuals : null}
									</SelectField>
									<div className="add-templete-btn">
										<RaisedButton label="Add New Template" labelColor="#fff" fullWidth={false} onClick={this.checkManual} />
									</div>
								</div>
								<h2 style={{ color: 'red', padding: "10px 0px" }}>{this.state.selectManual}</h2>
							</div>
							: null}

					</PanelGroup>

					<Dialog
						actions={actionNewTemplate}
						className="model-support"
						modal={false}
						contentClassName="model-top-overlay no-overlay"
						open={this.state.addTemplatemodalIsOpen}
						onRequestClose={this.closeModal}
					>

						<div className="other-popup-content learn-more-popup">
							<form className="import-job-modal">
								<h2>You are about to add a new manual. Please read the <a href="https://www.dokkit.co.uk/help" target="_blank">Help</a> pages first as this will have
implications on your information setup in simPRO</h2>
							</form>
						</div>
					</Dialog>
					<Dialog
						actions={actionDeleteTemplate}
						className="model-support"
						modal={false}
						contentClassName="model-top-overlay no-overlay"
						open={this.state.modalIsOpenDeleteTemp}
						onRequestClose={this.closeModalDeleteTemp}
					>

						<div className="other-popup-content learn-more-popup">
							<form className="import-job-modal" >
								<h2 >Do you want to remove this main template.?</h2>

							</form>
						</div>
					</Dialog>
					<Modal
						isOpen={this.state.modalIsOpen}
						onAfterOpen={this.afterOpenModal}
						onRequestClose={this.closeModal}
						style={customStyles}
						contentLabel="Template Upload Modal"
					>
						<form onSubmit={this.stopFormSubmit} name="uploadTemplateForm" className="upload-file-popup">

							{this.state.actionType !== 'newmain' ?
								<h2>{this.state.templatetitle}</h2>
								:
								<div>
									<h2>Main Template Name :</h2>
									<TextField
										required
										fullWidth={true}
										floatingLabelFixed={true}
										name='newMainTemplateName'
										type='text'
										value={this.state.newMainTemplateName}
										onChange={this.changeNewMainTemplateName}
										errorText={this.state.templateNameReq}
									/>
								</div>
							}
							{isUploadingFile && <LinearProgress mode="indeterminate" />}
							<div className="display-flex">

								<label htmlFor="template-file" id="upload-file-template">
									<input
										id="template-file"
										type="file"
										name="template-file"
										onChange={this.registerFileToUpload}
										ref={(input) => { this.filesInput = input; }}
										accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
										disabled={isUploadingFile}
									/>
									Choose File
						           	</label>
								<div id="upload-text">
									{this.state.uploadFiles ? this.state.uploadFiles[0].name : 'No file chosen...'}
								</div>
							</div>
							<div>
								<Row>
									<Col md={6}>
										<RaisedButton
											label={uploadLabel}
											type="submit"
											labelColor="#fff"
											fullWidth={true}
											onClick={(e) => { this.uploadTemplateFile(manual_id, template_id) }}
											disabled={isUploadingFile}
										/>
									</Col>
									<Col md={6}>
										<RaisedButton
											label="Cancel"
											type="submit"
											labelColor="#fff"
											fullWidth={true}
											onClick={this.closeModal}
											disabled={isUploadingFile}
										/>
									</Col>
								</Row>
							</div>
						</form>
					</Modal>

				</Col>
			</Row>
		)
	}
}

const mapStateToProps = (state, ownProps) => {

	let templates = {...state.templates}
	let template_items = templates.items || []

	templates.items = _.filter(template_items, function(o) {
	    return _.indexOf(ownProps.template_set.templates, o._id) > -1;
	});

	return {
		templates: templates,
		manuals: state.manuals,
		currentuser: state.login
	};
};

Templete = withRouter(connect(
	mapStateToProps,
	actions
)(Templete));

export default Templete;


// WEBPACK FOOTER //
// ./src/Components/Pages/Templete.js